import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_REG_NO
    SET_IS_ERROR
    SET_CHALLAN_DETAILS
    SET_MASKED_PHONE
    SET_WHATSAPP_CONSENT
    SET_IS_MAX_LIMIT_REACHED
    SET_CART_RESPONSE
    SET_CART_DETAILS
    SET_REGISTRATION_DETAILS
`,
    {
        prefix: "mychallans/"
    }
);
